export function createMarkdownBlob(title: string, markdown: string) {
  const blob = new Blob([markdown], { type: "text/markdown" });
  const url = URL.createObjectURL(blob);
  const filename = `${title || "document"}.md`;

  // create a temporary link element
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  // programmatically click the link to trigger the download
  link.click();

  // clean up by revoking the Blob URL
  URL.revokeObjectURL(url);
}
